const Guest = (props) => {
    return <div>{props.children}</div>
}

export default Guest;